var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile",on:{"click":function($event){return _vm.$router.push({name:'User'})}}},[_c('div',{staticClass:"initials"},[_vm._v("\n    "+_vm._s(_vm.userInitials)+"\n  ")]),_vm._v("\n  "+_vm._s(_vm.user.name)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42d4209e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Profile.vue
// module id = ZGSf
// module chunks = 1